import React from 'react';
import { SidebarTrigger } from '../ui/sidebar';
import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import { useLocation } from 'react-router';
import { routes } from '@/routing';
import { useTranslation } from 'react-i18next';
import { NotificationCenter } from './notification-center';

export const NavHeader: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const getActiveTitle = () => {
    if (location.pathname.startsWith(routes.creativeSuite)) {
      return {
        title: t('navHeader.creativeSuite.title'),
        description: t('navHeader.creativeSuite.description'),
      };
    }

    switch (location.pathname) {
      case routes.dashboard:
        return {
          title: t('navHeader.dashboard.title'),
          description: t('navHeader.dashboard.description'),
        };
      case routes.campaign:
        return {
          title: t('navHeader.campaigns.title', { defaultValue: 'Campaigns' }),
          description: t('navHeader.campaigns.description', {
            defaultValue: 'View and manage every campaign for this business.',
          }),
        };
      case routes.campaignCreate:
        return {
          title: t('navHeader.campaign.title'),
          description: t('navHeader.campaign.description'),
        };
      case routes.payments:
        return {
          title: t('navHeader.payments.title'),
          description: t('navHeader.payments.description'),
        };
      case routes.ledger:
        return {
          title: t('ledger.title'),
          description: t('ledger.subtitle'),
        };
      case '/analytics':
        return {
          title: t('navHeader.analytics.title'),
          description: t('navHeader.analytics.description'),
        };
      case '/audiences':
        return {
          title: t('navHeader.audiences.title'),
          description: t('navHeader.audiences.description'),
        };
      case '/settings':
        return {
          title: t('navHeader.settings.title'),
          description: t('navHeader.settings.description'),
        };
      default:
        return {
          title: t('navHeader.dashboard.title'),
          description: t('navHeader.dashboard.description'),
        }; // fallback
    }
  };

  const activeTitle = getActiveTitle();

  return (
    <header
      className={cn(
        'flex shrink-0 items-center gap-2 border-b bg-white backdrop-blur supports-[backdrop-filter]:bg-white',
        'sticky top-0 z-40 transition-all duration-200 ease-in-out shadow-sm',
        'block'
      )}
    >
      <div className="flex items-center justify-between w-full gap-2 px-4 py-3">
        <Link
          to="/"
          className="flex items-center gap-3 transition-opacity hover:opacity-80"
          aria-label={t('navHeader.ariaLabel')}
        >
          <div className="grid flex-1 text-sm leading-tight text-left">
            <span className="text-lg font-extrabold truncate text-slate-900">
              {activeTitle.title}
            </span>
            <span className="text-sm truncate text-slate-500">
              {activeTitle.description}
            </span>
          </div>
        </Link>
        <div className="flex items-center gap-1">
          <NotificationCenter />
          <SidebarTrigger
            className="w-8 h-8 transition-colors rounded-lg hover:bg-slate-100"
            aria-label={t('navHeader.sidebarToggleAriaLabel')}
          />
        </div>
      </div>
    </header>
  );
};
